module.exports = __webpack_public_path__ + "img/capacity-03.e4ed2c74.png";